import { Container, ContainerProps } from './Container';

export const HStack = (props: Omit<ContainerProps, 'direction'>) => (
  <Container direction="horizontal" {...props} />
);

export const VStack = (props: Omit<ContainerProps, 'direction'>) => (
  <Container direction="vertical" {...props} />
);
